import React from "react";
import { Badge } from "@/components/ui";
import { Blog } from "@/services/bedrock";
import { cn } from "@/lib/utils";

const LABELS: Record<Blog.Status, string> = {
  GENERATING: "Writing",
  DRAFT: "Draft",
  PUBLISHED: "Published",
  FAILED: "Failed",
};

const CLASSES: Record<Blog.Status, string> = {
  GENERATING: "border-sky-200 bg-sky-50 text-sky-700 hover:bg-sky-50",
  DRAFT: "border-amber-200 bg-amber-50 text-amber-800 hover:bg-amber-50",
  PUBLISHED: "border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-50",
  FAILED: "border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-50",
};

export const BlogStatusBadge: React.FC<{ status: Blog.Status }> = ({ status }) => (
  <Badge variant="outline" className={cn("font-semibold", CLASSES[status])}>
    {LABELS[status]}
  </Badge>
);
